import { createRoutine } from 'redux-saga-routines';

import { IUserState } from './index.interface';

const initialUsersState: IUserState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  users: [],
  submitting: false,
  invitationSuccess: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  },
}

export const getUsers = createRoutine('GET_USERS')
export const showUser = createRoutine('SHOW_USER')
export const updateUser = createRoutine('UPDATE_USER')
export const deactivateUser = createRoutine('DEACTIVATE_USER')
export const deleteUser = createRoutine('DELETE_USER')
export const inviteUser = createRoutine('INVITE_USER')
export const setPassword = createRoutine('SET_PASSWORD')
export const getCareManagers = createRoutine('GET_CARE_MANAGERS')
export const clearSelectedUser = createRoutine('CLEAR_SELECTED_USER')
export const clearInvitationStatus = createRoutine('CLEAR_INVITATION_STATUS')


export default (state = initialUsersState, action: any) => {
  switch (action.type) {
    case getUsers.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        users: [],
        meta: {}
      }
    case getUsers.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        users: action.payload.users,
        meta: action.payload.meta
      }
    case getUsers.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload,
        users: []
      }
    case getCareManagers.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        users: [],
        meta: {}
      }
    case getCareManagers.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        users: action.payload.users,
        meta: action.payload.meta
      }
    case getCareManagers.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload,
        users: []
      }
    // Update User
    case updateUser.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        success: false,
        message: ''
      }
    case updateUser.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        success: true,
      }
    case updateUser.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        submitting: false,
        message: action.payload
      }
    // show User
    case showUser.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        selectedUser: undefined,
        message: '',
      }
    case showUser.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        selectedUser: action.payload
      }
    case showUser.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        selectedUser: undefined,
        message: action.payload,
      }
    // Invite User
    case inviteUser.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        invitationSuccess: false,
      }
    case inviteUser.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        selectedUser: action.payload,
        invitationSuccess: true,
      }
    case inviteUser.FAILURE:
      return {
        ...state,
        error: true,
        submitting: false,
        invitationSuccess: false,
      }

    // Accept Invitation
    case setPassword.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: ''
      }
    case setPassword.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: ''
      }
    case setPassword.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload
      }

    // Deactivate User
    case deactivateUser.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        selectedUser: initialUsersState.selectedUser
      }
    case deactivateUser.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        selectedUser: action.payload
      }
    case deactivateUser.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload,
        selectedUser: initialUsersState.selectedUser
      }

    // Delete User
    case deleteUser.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        success: false,
        message: '',
      }
    case deleteUser.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        success: true,
        message: '',
        selectedUser: undefined
      }
    case deleteUser.FAILURE:
      return {
        ...state,
        error: true,
        submitting: false,
        success: false,
      }
    case clearSelectedUser.SUCCESS:
      return {
        ...state,
        selectedUser: undefined
      }
    case clearInvitationStatus.TRIGGER:
      return {
        ...state,
        invitationSuccess: false,
      }
    default:
      return { ...state }
  }
}
